import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import DateAndPaxModal from './DateAndPaxModal';
import {
  ATTRACTION,
  ATTRACTION_AVAILABILITY
} from '../../pages/[slug]/[slug2]';

interface ITopBarProps {
  headings: string[];
  attraction: ATTRACTION;
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

const TopBar: React.FC<ITopBarProps> = ({
  headings,
  attraction,
  isModalOpen,
  setIsModalOpen
}) => {
  const [activeHeading, setActiveHeading] = useState<string | null>(null);

  const handleClick = (heading: string) => {
    scrollToSection(heading);
  };
  const handleScroll = () => {
    const windowMidpoint = window.innerHeight / 5;

    let closestHeading = null;
    let closestDistance = Infinity;

    headings.forEach(heading => {
      const sectionId = heading.toLowerCase().replace(/\s+/g, '-');
      const element = document.getElementById(sectionId);

      if (element) {
        const rect = element.getBoundingClientRect();
        const distance = Math.min(
          Math.abs(rect.top - windowMidpoint),
          Math.abs(rect.bottom - windowMidpoint)
        );

        if (distance < closestDistance) {
          closestHeading = heading;
          closestDistance = distance;
        }
      }
    });

    setActiveHeading(closestHeading);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headings, setActiveHeading]);

  const scrollToSection = (heading: string) => {
    const sectionId = heading.toLowerCase().replace(/\s+/g, '-');
    const section = document.getElementById(sectionId);

    if (section) {
      const offset = section.offsetTop - 140;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };
  return (
    <>
      <div className="sticky z-[10] top-[55px]">
        <div className="sm:h-6 bg-white"></div>
        <div className="bg-[#F4F4F4]">
          <div className="flex justify-between items-center px-4 h-16">
            <div className="flex space-x-4 md:space-x-8 justify-between">
              {headings.map(heading => (
                <div
                  key={heading}
                  onClick={() => handleClick(heading)}
                  className={`cursor-pointer ${
                    activeHeading === heading
                      ? 'border-b-2 solid border-[#178ECC]'
                      : ''
                  }`}
                >
                  <span>{heading}</span>
                </div>
              ))}
            </div>
            {attraction?.tickets && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="hidden md:flex bg-primary hover:bg-[#2E3D7A] active:bg-[#2E3D7A] text-white px-[22px] py-[8px] rounded-[46px]"
              >
                Buy Ticket
              </button>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DateAndPaxModal
          attraction={attraction}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

export default TopBar;
